import { useQueryClient } from '@tanstack/react-query';
import { klwAxios } from 'helpers/api';
import { useEffect } from 'react';

import { MAINTENANCE_CONFIG_QUERY_KEY } from './queries';

export const useMaintenanceApiListener = (): void => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const interceptorId = klwAxios.interceptors.response.use(
      response => response,
      error => {
        if (error?.response?.status === 503) {
          queryClient.invalidateQueries({ queryKey: MAINTENANCE_CONFIG_QUERY_KEY });
        }

        return Promise.reject(error);
      }
    );

    return () => {
      klwAxios.interceptors.response.eject(interceptorId);
    };
  }, [queryClient]);
};
